export default __webpack_public_path__ + "static/media/roadmap.1323fbc5.png";